<div
  (click)="textarea.focus()"
  class="input-wrapper"
  onkeydown=""
  tabindex="0"
  (keyup)="textarea.focus()"
  >
  <textarea
    rows="1"
    class="input scrollable-textarea"
    placeholder="Typ hier je bericht..."
    #textarea
    [(ngModel)]="this.value"
    (keyup)="this.onChange(this.value); this.onTouch()"
    (change)="this.onTouch()"
  ></textarea>
  <div class="grid-desktop-1 grid-tablet-1 grid-mobile-1 controls">
    <div
      [class.text-danger]="this.formIsInvalid()"
      [class.text-subtitle]="!this.formIsInvalid()"
      >
      @if (this.formIsInvalid()) {
        <app-icon
          type="regular"
          icon="exclamation-triangle"
          />
      }
      {{ this.characterCount }} / {{ maxCharacters }} karakters
    </div>
    <ng-content select="[button]"></ng-content>
  </div>
</div>
